import { SECONDS_PER_MINUTE } from './constants';

export function getDurationInMinutes(durationInSeconds: number): number {
	return Math.ceil(durationInSeconds / SECONDS_PER_MINUTE);
}
